import { Theme, createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      minHeight: 'calc(100vh - 80px)',

      width: '100%',
    },
    gridCenterRoot: {
      gridGap: theme.spacing(3),
    },

    gridTitle: {
      color: 'white',
      fontWeight: 'bold',
      fontSize: 18,
      height: 60,
      lineHeight: '60px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      zIndex: 1000,
    },
    gridLeftPanelWrapper: {
      backgroundColor: theme.palette.secondary.main,
      position: 'sticky',
      top: 80,
      overflow: 'auto',
    },

    gridLeftPanel: {
      minHeight: 'calc(100vh - 80px)',
      height: 'calc(100vh - 80px)',
      fontSize: 12,
      lineHeight: 1.8,
      backgroundColor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
      fontWeight: 'normal',
    },
    handleLeft: {
      backgroundColor: theme.palette.secondary.main,
      position: 'fixed',
      top: 0,
      //marginLeft: 0,
      width: 6,
      height: '100vh',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    handleRight: {
      width: 6,
      '&:hover': {
        backgroundColor: '#DDD',
      },
    },
    upperPanel: {
      position: 'sticky',
      width: '100%',
      top: 0,
      zIndex: 5,
      backgroundColor: theme.palette.secondary.main,
      minHeight: 60,
    },
    centralPanel: {
      height: 'calc(100vh - 80px)',
    },
    gridCentralPanelBody: {
      padding: 32,
      paddingTop: 80,
    },
    loaderOverlay: {
      position: 'fixed',
      top: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 999,
      backgroundColor: 'rgba(255,255,255,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })
);
